/**
 * appProvider
 *
 * @author Dec Norton <decnorton@gmail.com>
 */

import get from 'lodash-es/get';
import config from '../config';

export function appProvider() {
    this.$get = $get;

    $get.$inject = ['$injector'];

    function $get($injector) {
        return $injector.instantiate(AppService);
    }
}

export class AppService {
    private _previousState: any;
    private _currentState: any;
    private _documentTitlePrefix: string;

    static get $inject() {
        return ['$toast', '$state', '$transitions', '$window'];
    }

    constructor(public $toast, public $state, public $transitions, public $window) {
        this._previousState = undefined;

        // Add properties from config to this.
        Object.keys(config).forEach(key => {
            this[key] = config[key];
        });

        this._onTransitionFinish.$inject = ['$transition$'];
        $transitions.onFinish({}, this._onTransitionFinish.bind(this));
    }

    static set documentTitle(title) {
        document.title = title;
    }

    _onTransitionFinish(transition) {
        this._previousState = transition.from();

        this._currentState = transition.to();

        this.updateTitle();
    }

    toast(message, hideDelay = 5000) {
        return this.$toast.toast(message, hideDelay);
    }

    progressToast(message = '') {
        return this.$toast.progressToast(message);
    }

    successToast(message) {
        return this.$toast.successToast(message);
    }

    errorToast(message, hideDelay = 5000) {
        return this.$toast.errorToast(message, hideDelay);
    }


    notificationToast(message, subMessage = null, callback, hideDelay = 10000) {
        return this.$toast.notificationToast(message, subMessage, callback, hideDelay)
    }

    back(defaultState) {
        if (defaultState && (!this._previousState || !this._previousState.name)) {
            this.$state.go(defaultState);
        } else {
            this.$window.history.back();
        }
    }

    updateTitle() {
        AppService.documentTitle = this.buildTitle();
    }

    setTitlePrefixForScope($scope, prefix) {
        this._documentTitlePrefix = prefix;

        this.updateTitle();

        if ($scope) {
            $scope.$on('$destroy', () => {
                this._documentTitlePrefix = null;

                this.updateTitle();
            });
        }
    }

    buildTitle(prefix = this._documentTitlePrefix) {
        let title = 'CareLineLive';

        const currentStateTitle = get(this._currentState, 'data.title');

        if (currentStateTitle) {
            title = `${get(this._currentState, 'data.title')} | ${title}`;
        }

        if (prefix) {
            title = `${prefix} - ${title}`;
        }

        return title;
    }
}
